import { apolloClient } from '~/apollo-client';
import { Flex_CreateMeterMutation, Flex_CreateMeterMutationVariables } from '~/typings/graphql';
import { CREATE_METER } from './create-meter.queries';

export type CreateMeterParams = {
  meterNumber: string;
  utilityAccountId: number;
};

export type CreateMeterResponse = {
  id: number;
  meterNumber: string;
  serviceType: string;
  utilityAccountId: number;
  utilityId: number;
};

export const createMeter = async (
  params: CreateMeterParams,
): Promise<CreateMeterResponse | undefined> => {
  const { data } = await apolloClient.mutate<
    Flex_CreateMeterMutation,
    Flex_CreateMeterMutationVariables
  >({
    mutation: CREATE_METER,
    variables: { input: params },
  });
  return data?.meter;
};
